import { ProviderGroup } from '../../../../lib/helpers/SmartSendBulkActionApplier';
import ProviderGroupSummaryTotalFallback from './ProviderGroupSummaryTotalFallback';
import ProviderGroupSummaryTotalVerified from './ProviderGroupSummaryTotalVerified';
import Loading from '~/components/loading/Loading';

interface props {
  group: ProviderGroup;
  /** The verified breakdown, or null when verification is off, failed, or returned nothing. */
  breakdown: Record<string, number> | null;
  verifying: boolean;
}

const ProviderGroupSummaryTotal: React.FC<props> = (props) => {
  if (props.verifying) {
    return <Loading />;
  }

  if (props.breakdown) {
    return <ProviderGroupSummaryTotalVerified breakdown={props.breakdown} currencyCode={props.group.CurrencyCode} />;
  }

  return <ProviderGroupSummaryTotalFallback group={props.group} />;
};

export default ProviderGroupSummaryTotal;
